module.exports = __webpack_public_path__ + "img/mariage-4.406a07eb.jpg";